import { createSelector } from 'reselect';
import { getAge, getPreciseValue, formatAmountWithoutDecimals } from '../utils/helpers';

export const getHouseholdSocialSecurityBenefits = (state: any) =>
  state.charts.simulationCurrentWant?.householdSocialSecurityBenefits;
export const getSpouseBpId = (state: any) => state.riScenario.spouseProfile?.bpId;
export const getIncomeGoal = (state: any) => {
  const {
    riScenario: { incomeGoal, incomeGoalUnit },
  } = state;
  const isRetirementNeedOverridden = incomeGoalUnit === 'DOL' ? true : false;
  if (isRetirementNeedOverridden) {
    return incomeGoal;
  }

  return Math.trunc(state.charts.simulationCurrentWant.householdAnnualReplacementIncomeAmount);
};
export const getParticipantSalary = (state: any) => {
  const {
    riScenario: { participantProfile, compensations },
  } = state;
  let participantCompensationRecord = { amount: 0 };
  if (compensations && participantProfile) {
    participantCompensationRecord = compensations.find((item: any) => item.bpId === participantProfile?.bpId);
  }
  return participantCompensationRecord.amount ? Math.trunc(participantCompensationRecord.amount) : 0;
};

export const getMultiClientInforation = (state: any): boolean => {
  const {
    riScenario: { accounts },
    participantProfile: { plans },
    // eslint-disable-next-line
    riScenario: { compensations },
  } = state;

  let isMulticlient = false;
  let terminatedAccountsCount = 0;
  const planNameOmniSet = new Set();
  const planNameTracSet = new Set();
  let rixAccountCount = 0;

  if (accounts != null) {
    for (const account of accounts) {
      if (account.clientNumber != null || account.planNumber != null) {
        rixAccountCount++;
      }
      if (account.status === 'TERMINATED') {
        terminatedAccountsCount++;
      }
      if (plans != null) {
        for (const plan of plans) {
          if (plan.clientNumber === account.clientNumber) {
            planNameOmniSet.add(account.clientNumber);
          }
          if (account.clientNumber == null && plan.planNumber === account.planNumber) {
            planNameTracSet.add(account.planNumber);
          }
        }
      }
    }

    if (rixAccountCount === terminatedAccountsCount) {
      isMulticlient = false;
    } else if (planNameOmniSet.size > 1 || planNameTracSet.size > 1) {
      isMulticlient = true;
    } else {
      isMulticlient = false;
    }
  }
  // console.log("isMulticlient "+ isMulticlient);
  return isMulticlient;
};

// export const checkPaycheckFrequency = (contributions:any): boolean => {
//   let result: boolean = false;
//   if (contributions) {
//     for (let contribution of contributions){
//       if (contribution.unit =='DOL') {
//         result = true;
//         break;
//       }
//     }
//   }
//   return result ;
// }

export const checkPaycheckFrequency = (clientNumber: string, planNumber: string, accounts: any): boolean => {
  let status = false;
  if (clientNumber == null && planNumber != null) {
    for (let i = 0; i < accounts.length; i++) {
      if (accounts[i].planNumber === planNumber && accounts[i].contribution != null) {
        for (let j = 0; j < accounts[i].contribution.length; j++) {
          if (accounts[i].contribution[j].unit === 'DOL') {
            status = true;
            break;
          }
        }
      }
    }
  }
  if (clientNumber != null) {
    for (let i = 0; i < accounts.length; i++) {
      if (accounts[i].clientNumber === clientNumber && accounts[i].contribution != null) {
        for (let j = 0; j < accounts[i].contribution.length; j++) {
          if (accounts[i].contribution[j].unit === 'DOL') {
            status = true;
            break;
          }
        }
      }
    }
  }
  return status;
};

export const checkSinglePlanOtherIncome = (compensations: any, accounts: any): boolean => {
  let terminatedAccountsCount = 0;
  let compStatus = false;
  let rixAccountCount = 0;

  if (compensations != null) {
    for (let i = 0; i < compensations.length; i++) {
      if (compensations[i].clientNumber == null && compensations[i].tracPlanNumber == null) {
        compStatus = true;
      }
    }
  }
  if ((compensations == null || compStatus) && accounts != null) {
    if (accounts != null) {
      for (const account of accounts) {
        if (account.clientNumber != null || account.planNumber != null) {
          rixAccountCount++;
        }
        if (account.status === 'TERMINATED') {
          terminatedAccountsCount++;
        }
      }
    }
  }
  return rixAccountCount === terminatedAccountsCount && terminatedAccountsCount > 0;
};

export const isSinglePlanOtherIncome = (state: any): boolean => {
  const {
    riScenario: { compensations },
    riScenario: { accounts },
  } = state;
  return checkSinglePlanOtherIncome(compensations, accounts);
};

export const getSinglePlan = (state: any): any => {
  const {
    riScenario: { compensations, spouseProfile, accounts },
  } = state;
  const singlePlan: any[] = [];

  if (checkSinglePlanOtherIncome(compensations, accounts)) {
    let spouseInfoBpid: any = null;
    if (spouseProfile != null && spouseProfile.bpId != null) {
      spouseInfoBpid = spouseProfile.bpId;
    }
    if (spouseInfoBpid != null) {
      for (let i = 0; i < compensations.length; i++) {
        if (spouseInfoBpid != null && compensations[i].bpId !== spouseInfoBpid) {
          for (const account of accounts) {
            singlePlan.push({
              id: compensations[i].id,
              action: compensations[i].action,
              clientNumber: compensations[i].clientNumber,
              salaryName: account.name,
              accountId: account.bpId,
              compensationId: compensations[i].bpId,
              salary: compensations[i].amount,
              paymentFrequency: compensations[i].payFrequency,
              status: account.status,
              compensationType: compensations[i].compensationType,
              displayPayroll: checkPaycheckFrequency(account.clientNumber, account.planNumber, accounts),
            });
            break;
          }
        }
      }
    } else {
      for (let i = 0; i < compensations.length; i++) {
        for (const account of accounts) {
          singlePlan.push({
            id: compensations[i].id,
            action: compensations[i].action,
            clientNumber: compensations[i].clientNumber,
            salaryName: account.name,
            accountId: account.bpId,
            compensationId: compensations[i].bpId,
            salary: compensations[i].amount,
            paymentFrequency: compensations[i].payFrequency,
            status: account.status,
            compensationType: compensations[i].compensationType,
            displayPayroll: checkPaycheckFrequency(account.clientNumber, account.planNumber, accounts),
          });
          break;
        }
      }
    }
  }

  if (compensations != null && accounts != null) {
    for (let i = 0; i < compensations.length; i++) {
      /* Omni plan */
      if (compensations[i].clientNumber != null && compensations[i].tracPlanNumber == null) {
        for (let j = 0; j < accounts.length; j++) {
          if (
            compensations[i].clientNumber != null &&
            accounts[j].clientNumber != null &&
            compensations[i].clientNumber === accounts[j].clientNumber
          ) {
            singlePlan.push({
              id: compensations[i].id,
              action: compensations[i].action,
              clientNumber: compensations[i].clientNumber,
              salaryName: accounts[j].name,
              accountId: accounts[j].bpId,
              compensationId: compensations[i].bpId,
              salary: compensations[i].amount,
              paymentFrequency: compensations[i].payFrequency,
              status: accounts[j].status,
              compensationType: compensations[i].compensationType,
              tracPlanNumber: null,
              displayPayroll: checkPaycheckFrequency(accounts[j].clientNumber, accounts[j].planNumber, accounts),
            });
            break;
          }
        }
      }
      /* Trac Plan */

      if (compensations[i].clientNumber === null && compensations[i].tracPlanNumber != null) {
        for (let j = 0; j < accounts.length; j++) {
          if (
            compensations[i].tracPlanNumber != null &&
            accounts[j].planNumber != null &&
            compensations[i].tracPlanNumber === accounts[j].planNumber
          ) {
            singlePlan.push({
              id: compensations[i].id,
              action: compensations[i].action,
              clientNumber: compensations[i].clientNumber,
              salaryName: accounts[j].name,
              accountId: accounts[j].bpId,
              compensationId: compensations[i].bpId,
              salary: compensations[i].amount,
              paymentFrequency: compensations[i].payFrequency,
              status: accounts[j].status,
              compensationType: compensations[i].compensationType,
              tracPlanNumber: compensations[i].tracPlanNumber,
              displayPayroll: checkPaycheckFrequency(accounts[j].clientNumber, accounts[j].planNumber, accounts),
            });
          }
        }
      }
    }
  }
  return singlePlan;
};

export const getOtherIncome = (state: any): number => {
  const {
    riScenario: { compensations },
  } = state;
  let amount = 0;
  if (compensations != null) {
    for (let i = 0; i < compensations.length; i++) {
      for (let j = i + 1; j < compensations.length; j++) {
        if (
          compensations[i].bpId === compensations[j].bpId &&
          compensations[j].clientNumber === null &&
          compensations[j].tracPlanNumber === null
        ) {
          amount = compensations[j].amount;
          // console.log("other income: "+ amount)
          return amount;
        }
      }
    }
  }

  return amount;
};

export const getOtherIncomeSingleClient = (state: any): any => {
  const {
    riScenario: { participantProfile, compensations },
  } = state;

  let otherIncome: any = null;
  // console.log("SingleClientCompensations: "+ JSON.stringify(compensations));
  // console.log("SingleClientParticipantProfile: "+ JSON.stringify(participantProfile));

  if (compensations && participantProfile) {
    for (let i = 0; i < compensations.length; i++) {
      // console.log("participantProfile.bpId "+ participantProfile.bpId+
      // " compensations[i].bpId " + compensations[i].bpId +
      // " compensations[i].clientNumber  "+ compensations[i].clientNumber +
      // " compensations[i].tracPlanNumber "+ compensations[i].tracPlanNumber)

      if (
        participantProfile.bpId != null &&
        compensations[i].bpId != null &&
        compensations[i].bpId === participantProfile.bpId &&
        compensations[i].clientNumber == null &&
        compensations[i].tracPlanNumber == null
      ) {
        otherIncome = {
          id: compensations[i].id,
          compensationType: compensations[i].compensationType,
          bpId: compensations[i].bpId,
          clientNumber: compensations[i].clientNumber,
          amount: compensations[i].amount,
        };
      }
    }
  }
  // console.log("getOtherIncomeSingleClient: "+ JSON.stringify(otherIncome));
  return otherIncome;
};

export const getMulticlientParticipantSalary = (state: any): number => {
  const {
    riScenario: { accounts, compensations },
  } = state;
  let salary = 0;
  if (accounts != null && compensations != null) {
    for (const account of accounts) {
      for (const compensation of compensations) {
        if (compensation.clientNumber === account.clientNumber) {
          salary += compensation.amount;
          break;
        }
      }
    }
  }
  return salary;
};

export const getSpouseSalary = (state: any) => {
  const {
    riScenario: { spouseProfile, compensations },
  } = state;
  let spouseCompensationRecord = { amount: 0 };
  if (compensations && spouseProfile) {
    spouseCompensationRecord =
      compensations.find((item: any) => item.bpId === spouseProfile?.bpId) || spouseCompensationRecord;
  }
  return Math.trunc(spouseCompensationRecord.amount);
};

export const getParticipantAge = (state: any) => {
  const {
    riScenario: { participantProfile },
  } = state;
  return getAge(participantProfile.birthDate);
};

export const getSpouseAge = (state: any) => {
  const {
    riScenario: { spouseProfile },
  } = state;
  return spouseProfile ? getAge(spouseProfile.birthDate) : 0;
};

export const getSuggestedTotalContribution = (state: any) => {
  const {
    contribution: {
      originalContributions: { contributions },
    },
    charts: { simulationCurrentWant },
  } = state;

  if (!contributions || !simulationCurrentWant) {
    return 0;
  }

  const { householdAccountAdvice } = simulationCurrentWant;

  if (!contributions || contributions.length === 0 || !householdAccountAdvice || householdAccountAdvice.length === 0) {
    return 0;
  }

  let onTrack = true,
    suggestedTotalContribution = 0,
    unit = '',
    //eslint-disable-next-line
    allUnits = [];

  if (contributions.some((c: any) => c.planLevelUnit === 'N/A')) {
    return 0;
  } else {
    for (let i = 0; i < contributions.length; i++) {
      if (contributions[i].contribution && contributions[i].contribution.length > 0) {
        if (
          (unit === 'DOL' || unit === '') &&
          contributions[i].contribution.every((contributionUnit: any) => contributionUnit.unit === 'DOL')
        ) {
          unit = 'DOL';
        } else {
          unit = 'PCT';
        }

        allUnits.push(unit);
      }
    }
  }

  for (let i = 0; i < contributions.length; i++) {
    const contribution = contributions[i];
    const planContributions = contribution.contribution ? contribution.contribution : [];
    for (let j = 0; j < planContributions.length; j++) {
      const planContribution = planContributions[j];
      const currentContribution = planContribution.amount;
      const currentAdvice = householdAccountAdvice.find(
        (advice: any) =>
          advice.AccountName.indexOf(contribution.planNumber) > -1 &&
          advice.AccountName.lastIndexOf(planContribution.id) === advice.AccountName.length - 1,
      );
      const suggestedContribution = currentAdvice
        ? unit === 'PCT'
          ? getPreciseValue(Number(currentAdvice.AccountSavings[0].SavingsPercentage) * 100)
          : Number(currentAdvice.AccountSavings[0].SavingsAmount)
        : 0;
      if (currentContribution < suggestedContribution) {
        onTrack = false;
        suggestedTotalContribution = suggestedTotalContribution + suggestedContribution;
      }
    }
  }

  return onTrack
    ? 0
    : unit === 'PCT'
    ? Math.trunc(suggestedTotalContribution) + '%'
    : formatAmountWithoutDecimals(suggestedTotalContribution);
};

export const getSuggestedContributionAsJson = (state: any) => {
  const suggestedData: any = {
    allUnits: [],
    allCatchpUnits: [],
    hasMixedUnit: false,
    onTrack: false,
    accounts: [],
    planMaxAmountDollar: [],
    planMaxAmountPercent: [],
    totalSuggestedBreakdown: 0,
    totalSuggestedBreakdownAmount: 0,
    hasHouseholdAccountAdvice: true,
  };

  const {
    contribution: {
      originalContributions: { contributions },
    },
    charts: { simulationCurrentWant },
  } = state;

  if (!contributions || !simulationCurrentWant) {
    return 0;
  }

  // Checking off track / on track
  suggestedData.onTrack = simulationCurrentWant.runoutAge > 0 ? false : true;

  const { householdAccountAdvice } = simulationCurrentWant;

  if (!contributions || contributions.length === 0) {
    return 0;
  }

  if (!householdAccountAdvice || householdAccountAdvice.length === 0) {
    suggestedData.hasHouseholdAccountAdvice = false;
    return suggestedData;
  }

  for (let i = 0; i < contributions.length; i++) {
    const filteredAdvices = householdAccountAdvice.filter(
      (advice: any) => advice.AccountName.indexOf(contributions[i].planNumber) > -1,
    );

    if (!(contributions[i] && contributions[i].contribution)) {
      continue;
    }

    for (let j = 0; j < contributions[i].contribution.length; j++) {
      if (contributions[i].contribution[j].id !== '$' && contributions[i].contribution[j].id !== '#') {
        suggestedData.allUnits.push(contributions[i].contribution[j].unit);
      } else {
        suggestedData.allCatchpUnits.push(contributions[i].contribution[j].unit);
      }

      const currentAdvice = filteredAdvices.filter(
        (advice: any) =>
          advice.AccountName.lastIndexOf(contributions[i].contribution[j].id) === advice.AccountName.length - 1,
      );
      const hasAdvice = currentAdvice.length > 0;
      //eslint-disable-next-line
      let suggestedBreakdown = 'N/A';

      if (hasAdvice && contributions[i].contribution[j].unit === 'PCT') {
        const savingsPercent = getPreciseValue(Number(currentAdvice[0].AccountSavings[0].SavingsPercentage) * 100);
        const suggestedBreakdownAmount = savingsPercent > contributions[i].contribution[j].amount ? savingsPercent : 0;
        suggestedBreakdown = suggestedBreakdownAmount > 0 ? suggestedBreakdownAmount + '%' : 'N/A';
        suggestedData.totalSuggestedBreakdown = suggestedData.totalSuggestedBreakdown + suggestedBreakdownAmount;
      } else if (hasAdvice && contributions[i].contribution[j].unit === 'DOL') {
        const savingsAmount = Math.trunc(Number(currentAdvice[0].AccountSavings[0].SavingsAmount));

        // console.log('+++', {
        //   savingsAmount: savingsAmount,
        //   contribAmount: contributions[i].contribution[j].amount
        // })

        const suggestedBreakdownAmount = savingsAmount > contributions[i].contribution[j].amount ? savingsAmount : 0;
        suggestedBreakdown = suggestedBreakdownAmount > 0 ? '$' + suggestedBreakdownAmount : 'N/A';
        suggestedData.totalSuggestedBreakdownAmount =
          suggestedData.totalSuggestedBreakdownAmount + suggestedBreakdownAmount;
      }
    }

    contributions[i].planMaxAmountDollar &&
      suggestedData.planMaxAmountDollar.push(contributions[i].planMaxAmountDollar);
    contributions[i].planMaxAmountPercent &&
      suggestedData.planMaxAmountPercent.push(contributions[i].planMaxAmountPercent * 100);

    // contributions[i].suggestedBreakdown && (suggestedData.totalSuggestedBreakdown = suggestedData.totalSuggestedBreakdown + contributions[i].suggestedBreakdown);
  }
  //eslint-disable-next-line
  const hasAllSameUnit = arrayHasAllSameValues(suggestedData.allUnits.concat(suggestedData.allCatchpUnits));
  suggestedData.hasMixedUnit = !hasAllSameUnit;

  return suggestedData;
};

/**
 * Checking all the array items are same or not
 * @param arr An array
 * @returns Boolean
 */
const arrayHasAllSameValues = (arr: any) => arr.every((v: any) => v === arr[0]);

export const getRetirementAgeAdvice = (state: any) => {
  const {
    riScenario: { retirementStartAge },
    charts: { simulationCurrentWant },
  } = state;
  if (!retirementStartAge || !simulationCurrentWant) {
    return 0;
  }
  const { adviceRetirementAge } = simulationCurrentWant;
  return !adviceRetirementAge || retirementStartAge >= adviceRetirementAge ? 0 : adviceRetirementAge;
};
//const getParticipantBpId = (state: any) => state.riScenario.participantProfile?.bpId;

export const getTotalCompensation = createSelector(
  [getParticipantSalary, getSpouseSalary, getOtherIncomeSingleClient, isSinglePlanOtherIncome],
  (participantSalary, spouseSalary, otherIncome) => {
    let totalCompensation = 0;
    let otherIncomeAmount = 0;
    if (otherIncome != null && otherIncome.amount > 0 && !isSinglePlanOtherIncome) {
      otherIncomeAmount = otherIncome.amount;
      totalCompensation = participantSalary + spouseSalary + otherIncomeAmount;
    } else {
      totalCompensation = participantSalary + spouseSalary;
    }
    console.log(
      'participantSalary: ' +
        participantSalary +
        ' spouseSalary: ' +
        spouseSalary +
        ' otherIncomeAmount ' +
        otherIncomeAmount,
    );
    return totalCompensation;
  },
);

export const getSpouseSocialSecurityAdvice = createSelector(
  [getHouseholdSocialSecurityBenefits, getSpouseBpId],
  (householdSocialSecurityBenefits, bpId) => {
    let spouseSocialSecurityAdvice: Array<{}> = [];
    if (!householdSocialSecurityBenefits) {
      return [];
    }
    householdSocialSecurityBenefits.forEach((item: any) => {
      if (item.Name.includes(bpId)) {
        spouseSocialSecurityAdvice = item.Payment;
      }
    });
    return spouseSocialSecurityAdvice;
  },
);

export const getParticipantSocialSecurityAdvice = createSelector(
  [getHouseholdSocialSecurityBenefits, getSpouseBpId],
  (householdSocialSecurityBenefits, bpId) => {
    let participantSocialSecurityAdvice: Array<{}> = [];
    if (!householdSocialSecurityBenefits) {
      return [];
    }
    householdSocialSecurityBenefits.forEach((item: any) => {
      if (!item.Name.includes(bpId)) {
        participantSocialSecurityAdvice = item.Payment;
      }
    });
    return participantSocialSecurityAdvice;
  },
);

export const getMulticlientAggregatedCompensation = createSelector(
  [getMulticlientParticipantSalary, getSpouseSalary, getOtherIncome],
  (multiclientParticipantSalary, spouseSalary, otherIncome) => {
    return multiclientParticipantSalary + spouseSalary + otherIncome;
  },
);
